/**
 * Copy text to clipboard. Works on HTTP (e.g. VPS IP) where navigator.clipboard is blocked.
 */
export async function copyToClipboard(text) {
  const value = String(text ?? '').trim();
  if (!value) {
    throw new Error('Không có nội dung để sao chép');
  }

  if (navigator.clipboard?.writeText && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(value);
      return;
    } catch {
      // fall through to legacy copy
    }
  }

  const textarea = document.createElement('textarea');
  textarea.value = value;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.left = '-9999px';
  textarea.style.top = '0';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  textarea.setSelectionRange(0, value.length);

  let ok = false;
  try {
    ok = document.execCommand('copy');
  } finally {
    document.body.removeChild(textarea);
  }

  if (!ok) {
    throw new Error('Không thể sao chép');
  }
}
